import 'react-phone-number-input/style.css';

import React from 'react';
import PhoneInput from 'react-phone-number-input/min';
import styled from 'styled-components';

import { colors } from '../../../core';
import { AnimatedLabel } from '../TextInput';

export const ArrowComponent = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 10.5L12 15.5L17 10.5H7Z" fill="currentColor" />
  </svg>
);

export const Container = styled.div<{
  hasEnteredText?: boolean;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}>`
  & ${AnimatedLabel} {
    left: 72px;
  }

  ${({ hasEnteredText }) =>
    hasEnteredText &&
    `
    & ${AnimatedLabel} {
      left: 16px;
      top: 0;
      font-size: 12px;
    }
  `}

  &:focus-within {
    & ${AnimatedLabel} {
      left: 16px;
    }
  }

  ${({ disabled, theme }) =>
    disabled &&
    `
    .input-wrapper {
      pointer-events: none;
    }

    .input-wrapper, .input-wrapper:focus, .input-wrapper:active {
      .PhoneInputCountryIconImg, svg {
        fill: ${theme.textInputDisabledColor || colors.smoke}
      }

      img.PhoneInputCountryIconImg {
        opacity: 0.2;
      }
    }
`}
`;

export const StyledPhoneInput = styled(PhoneInput)`
  width: 100%;
  height: ${({ theme }) => `calc(${theme.textInputHeight} - 2px)` || '34px'};

  .PhoneInputCountryIcon--border {
    box-shadow: none;
  }

  .PhoneInputCountrySelect > option {
    font-family: ${({ theme }) => theme.fontFamily };
    font-size: 16px;
    font-weight: 500;
  }

  input {
    border: 0;
    height: 100%;
    background-color: transparent;
    color: ${({ theme }) => theme.textInputColor || colors.ash};
    font-family: ${({ theme }) => theme.fontFamily };
    font-size: ${({ theme }) => theme.fontSize || '14px'};
    font-weight: ${({ theme }) => theme.fontWeight || 600};

    &:active,
    &:focus {
      outline: 0;

      ::placeholder {
        color: ${({ theme }) => theme.textInputPlaceholderColor || colors.smoke};
      }
    }

    ::placeholder {
      color: ${({ theme }) => theme.textInputPlaceholderColor || colors.smoke};
    }
  }
`;
